import { PRO_RATA_SETTINGS } from '../CreatePlanForm/create-plan-form-types/create-plan-form-sub-types';

export const prorationOptions = [
  {
    value: PRO_RATA_SETTINGS.PRO_RATA_AND_CALENDAR_ALIGNED,
    label: {
      title: 'Calendar-aligned with proration',
      subTitle: 'Sync billing to calendar dates (e.g. 1st of month) and adjust charges for partial periods.',
    },
  },
  {
    value: PRO_RATA_SETTINGS.PRO_RATA,
    label: {
      title: 'Pro rata',
      subTitle: 'Charge partial amounts based on time or usage when subscriptions change.',
    },
  },
  {
    value: PRO_RATA_SETTINGS.DISABLED,
    label: {
      title: 'No proration',
      subTitle: 'Charge full billing periods only. No adjustments for mid-cycle changes.',
    },
  },
];
